import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    ExcelService,

    PurchaseOrderService,
    PurchaseReportService
} from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./invoicereport.component.html",
})
export class PurchaseInvoiceReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  dataList = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  partyList: Observable<any[]>;
  exceldata: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "invoice_no",
    orderDir: "asc",
  };
  colorList = [];
  widthList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  finyearCtrl: FormControl = new FormControl();

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    namecode: "",
  };
  finyearList = [];
  partycodeList = [];
  reportTypeList = ["DESIGN NO", "PARTY", "INVOICE"];

  filter = {
    groupby: "INVOICE",
    party_code: "",
    fin_id: "",
    po_from: "",
    po_to: "",
    inv_from: "",
    inv_to: "",
    inv_from_date: "",
    inv_to_date: "",
    mtr_from: "",
    mtr_to: "",
    rate_from: "",
    rate_to: "",
    design_no: "",
    shade: "",
    pcs: "",
    color: [],
    width: [],
  };

  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Invoice/LR Report",
    columns: [],
    rows: [],
  };

  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purService: PurchaseReportService,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
    private poservice: PurchaseOrderService,
    private combo2Service: Combo2Service,
    private poService: PurchaseOrderService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getInvoiceList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
        headerClass: "text-center",
      },
      {
        name: "Inv No",
        prop: "invoice_no",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        cellClass: "text-center",
        align: "right",
        type: "number",
        headerClass: "text-center",
      },
      {
        name: "Date",
        prop: "fdate",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Partycode",
        prop: "party_code",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Party",
        prop: "party_name",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
        sortable: false,
        headerClass: "text-center",
      },
    ];

    this.finyearCombo();
    this.colorlist();
    this.widthlist();
    this.codelist();
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterinvno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    //this.getInvoiceList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    // this.getInvoiceList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getInvoiceList();
  }

  onClickcolor(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.color = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  onClickwidth(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.width = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.partycodeList = res.data;
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.fin_id = res.data[0].fin_id;
      this.getInvoiceList();
    });
  }

  colorlist() {
    this.poService.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  widthlist() {
    this.poService.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  onbackbutton() {
    this.filter.groupby = "DESIGN NO";
    this.filter.design_no = "";

    this.getInvoiceList();
  }

  onCellClick(event) {
    this.filter.groupby = "DESIGN SHADE";
    this.filter.design_no = event.row.design_no;
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.isLoadMask = that.purService
      .getInvDesignReport(params)
      .then(function (res: any) {
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
      });
  }

  getInvoiceList(): void {
    this.filter.inv_from_date = this.datePipe.transform(
      this.filter.inv_from_date,
      "yyyy-MM-dd"
    );
    this.filter.inv_to_date = this.datePipe.transform(
      this.filter.inv_to_date,
      "yyyy-MM-dd"
    );
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.purService
      .getLRinvReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };

        that.printConfig = {
          title: "Invoice/LR Report",
          columns: res.columns,
          rows: that.invoiceData,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  clearFilter(): void {
    this.filterData.namecode = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getInvoiceList();
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/LRinvoiceReport/invoicereport.component.ts